// extracted by mini-css-extract-plugin
module.exports = {"link":"_3oqF5","root":"_1P1ro","label":"_22ngm"};